module.exports = __webpack_public_path__ + "img/circle_white_desktop.8355fa5a.png";